import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import {swiperObserver} from "../../utils/swiper.utils.js";

let relatedStoriesSwiperWr = document.querySelectorAll('.related-stories-swiper-wr');
relatedStoriesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');

    if (!swiperEl) {
      return;
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true,
      observeParents: true,
      spaceBetween: 12,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        500: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        641: {
          spaceBetween: 20,
          slidesPerView: 1.3,
        },
        961: {
          spaceBetween: 24,
          slidesPerView: 1.5,
        },
        1100: {
          spaceBetween: 28,
          slidesPerView: 2.05,
        },
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });

    swiperObserver(swiper);

    const titlesArr = swiperEl.querySelectorAll('.success-stories-card__text');
    if(titlesArr.length) {
      lineTitlesFunc(titlesArr);
    }

    const titlesSecondArr = swiperEl.querySelectorAll('.success-stories-card__title');
    if(titlesSecondArr.length) {
      lineTitlesFunc(titlesSecondArr);
    }
  }
});
